import React from 'react';
import { Image } from 'react-bootstrap';
import lekeTedavisi from '../../images/home/taniTedavi/16001738625587.jpg';
import '../../styles/about.css';

const TaniTedavi7 = () => {
    return (
        <div>
            <h5 className='main-title'>KÜÇÜK CERRAHİ GİRİŞİMLER</h5>
            <hr />
            <p>Bir kulak burun boğaz doktoru, muayenehane ya da ofis ortamında bir çok küçük cerrahi girişim yapabilir. Çoğu merkezde, öğle arası cerrahi olarak adlandırılan bu müdahaleler, günümüz çalışma şartlarında hastalara zaman kazandırması açısından büyük fayda sağlar. Eskiden bademcik ameliyatları bile lokal anestezi ile poliklinik şartlarında yapılırdı. Ancak anestezinin çok gelişmesiyle hemen hemen terk edilmiştir.</p>
            <Image src={lekeTedavisi} fluid className='mb-4' style={{ width: '100%' }} />
            <p>KBB ve Baş Boyun bölgesi lokal anestezi ile yapılacak müdahalelere çok uygun olduğu için gerek teşhis, gerek tedavi, gerekse pansuman gibi hasta takibini gerektirecek birçok işlemi rahatlıkla yapmaktayız.</p>
            <p>Bunlar sırasıyla:</p>
            <ul>
                <li>Horlama hastalarında RADYOFREKANS ile yumuşak damağa yapılan müdahaleler.</li>
                <li>Horlama hastalarında yumuşak damağa PİLLAR İMPLANT denilen polietilen materyalin yerleştirilmesi.</li>
                <li>Kronik orta kulak iltihaplarında parasentez ile kulak zarının çizilerek delinmesi, gerekirse kulak tüpü uygulaması.</li>
                <li>Kronik orta kulak iltihaplarında kulak kurutma pansumanları ve kulak zarı ameliyatına hazırlık.</li>
                <li>Boyunda, ensede ve kulak kepçesi civarında gelişen lipom gibi yağ bezelerinin ve kistlerin çıkarılması.</li>
                <li>Dudaklardan başlamak üzere ağız içindeki lezyonların çıkarılması ve biyopsi alınması.</li>
                <li>Tükürük bezi kanallarında gelişen taşların alınması.</li>
                <li>Burun tıkanıklığında alt burun etlerinin lokal anestezi ile RADYOFREKANS kullanılarak küçültülmesi.</li>
                <li>Burun kanamalarına kanayan bölgenin ya da damarın koterizasyonu.</li>
                <li>Estetik amaçlı olarak yüz üst bölgesine yapılan müdahaleler.</li>
                <li>Botox uygulaması.</li>
            </ul>
        </div>

    );
};

export default TaniTedavi7;
